/**
 * Defines a type for the different steps on the termination flow
 */
type TerminationStatus = null | 'INITIAL_CONFIRMATION' | 'CHECK_VOLUNTARY' | 'TERMINATION_DATE' | 'TERMINATION_REASON' | 'FINAL_CONFIRMATION' | 'SUBMITTING'

export const terminationFlowOrder: TerminationStatus[] = ['INITIAL_CONFIRMATION', 'CHECK_VOLUNTARY', 'TERMINATION_DATE', 'TERMINATION_REASON', 'FINAL_CONFIRMATION', 'SUBMITTING']

export default TerminationStatus


// WEBPACK FOOTER //
// ./src/routes/terminations/termination-flow/TerminationFlowStatus.type.ts